import { useQuery } from "@apollo/client";
import { useState } from "react";

import { AuthProviderContext, AuthenticationStatus } from "./context";
import { computeAuthenticationStatus } from "./utils";
import { CurrentUserDocument } from "../../graphql/graphql";

interface AuthProviderProps {
  children: React.ReactNode;
}

/**
 * Call the GraphQL API and get the currentUser to check if the user is authenticated.
 */
export const AuthProvider = ({ children, ...props }: AuthProviderProps) => {
  const [authenticationStatus, setAuthenticationStatus] = useState(
    AuthenticationStatus.LOADING,
  );
  const { data, loading, error } = useQuery(CurrentUserDocument);

  const computedAuthenticationStatus = computeAuthenticationStatus(
    data,
    loading,
    error,
  );
  // Only update the authenticated state if the value has changed.
  if (authenticationStatus !== computedAuthenticationStatus) {
    setAuthenticationStatus(computedAuthenticationStatus);
  }

  return (
    <AuthProviderContext.Provider value={{ authenticationStatus }} {...props}>
      {children}
    </AuthProviderContext.Provider>
  );
};
